// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0d862e10","460":"b334bc2d","996":"270fe38e"}[chunkId] + ".chunk.js";
};